import wyPluginClient from './wyPluginClient.js';
import {
  resolveRedirectOrBinaryMediaUrl,
  buildMediaSourceResult
} from './musicPluginProxy.js';

/**
 * 洛雪音乐「长青SVIP音源」脚本 - 网易云线路
 * 解析后端是裸IP(175.27.166.236) + HTTP，与现有 wyPluginClient
 * (music.haitangw.cc, HTTPS，失败回退网易官方) 完全不同，因此作为独立音源呈现。
 *
 * 注意：裸IP + HTTP 意味着没有域名信誉与TLS保护，若该IP将来变更或不可用，
 * 此音源会直接失败（不会影响其他音源）。
 */
const PLATFORM = 'lx-wy';
const SOURCE_TAG = 'lx-wy-plugin';

const LEVELS = {
  low: 'standard',
  standard: 'standard',
  high: 'exhigh',
  super: 'lossless'
};

const REQUEST_HEADERS = {
  Referer: 'https://music.163.com/',
  'User-Agent':
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36'
};

async function search(query, page = 1) {
  const result = await wyPluginClient.search(query, page);
  return {
    ...result,
    data: result.data.map((song) => ({ ...song, source: SOURCE_TAG }))
  };
}

async function getMediaSource(musicItem, quality = 'high') {
  const songId = musicItem?.id || musicItem?.raw?.id;
  if (!songId) {
    throw new Error('网易歌曲ID不能为空');
  }

  const level = LEVELS[quality] || LEVELS.high;
  const audioUrl = `http://175.27.166.236/wy1/wy.php?type=mp3&id=${songId}&level=${level}`;

  try {
    const audioData = await resolveRedirectOrBinaryMediaUrl(audioUrl, REQUEST_HEADERS);
    return buildMediaSourceResult(audioData, musicItem, quality);
  } catch (primaryError) {
    console.warn('[lxWyPluginClient] 长青线路获取失败，回退官方网易客户端:', primaryError.message);
    return wyPluginClient.getMediaSource(musicItem, quality);
  }
}

async function getLyric(musicItem, options = {}) {
  if (options.cachedLyric?.lrc) {
    return options.cachedLyric;
  }

  try {
    const result = await getMediaSource(musicItem, 'high');
    if (result.lyric?.lrc) {
      return result.lyric;
    }
  } catch (error) {
    console.warn('[lxWyPluginClient] 长青线路获取歌词失败，回退官方网易客户端:', error.message);
  }

  return wyPluginClient.getLyric(musicItem, options);
}

const lxWyPluginClient = {
  platform: PLATFORM,
  version: '1.0.0',
  search,
  getMediaSource,
  getLyric
};

export default lxWyPluginClient;
